import { Product } from "../../services/types/gallus";

export const productsData: Product[] = [
   {
    Name: "Demo",
    Permissions: ["Demov2"],
    URLProduct: "/demov2",
    IsFree: true,
    Enabled: true,
  },
  {
    Name: "Cambio",
    Permissions: ["CHM"],
    URLProduct: "/cambio",
    IsFree: true,
    Enabled: true,
  },
  {
    Name: "CK",
    Permissions: ["Celink"],
    URLProduct: "/celink",
    IsFree: true,
    Enabled: true,
  },
  // {
  //   Name: "Demo",
  //   Permissions: ["Demo"],
  //   URLProduct: "/demo",
  //   IsFree: true,
  //   Enabled: true,
  // },
  {
    Name: "FM",
    Permissions: ["FCM"],
    URLProduct: "/fcm",
    IsFree: true,
    Enabled: true,
  },
  {
    Name: "Flx",
    Permissions: ["Flexpoint"],
    URLProduct: "/flexpoint",
    IsFree: true,
    Enabled: true,
  },
  {
    Name: "TLS",
    Permissions: ["LoanStore"],
    URLProduct: "/loanstore",
    IsFree: true,
    Enabled: true,
  },
  {
    Name: "Nm",
    Permissions: ["Northern"],
    URLProduct: "/northernmortgage",
    IsFree: true,
    Enabled: true,
  },
  {
    Name: "Panda",
    Permissions: ["PMG"],
    URLProduct: "/pmg",
    IsFree: true,
    Enabled: true,
  },
  {
    Name: "PRMG",
    Permissions: ["PRMG"],
    URLProduct: "/prmgprod",
    IsFree: true,
    Enabled: true,
  },
  {
    Name: "PRMG UAT",
    Permissions: ["PRMGUAT"],
    URLProduct: "/prmgUAT2",
    IsFree: true,
    Enabled: true,
  },
  {
    Name: "RD",
    Permissions: ["Radius"],
    URLProduct: "/radius",
    IsFree: true,
    Enabled: true,
  },
  {
    Name: "RLT",
    Permissions: ["Reliant"],
    URLProduct: "/reliant",
    IsFree: true,
    Enabled: true,
  },
  {
    Name: "DC",
    Permissions: ["DinerCap"],
    URLProduct: "/dinercap",
    IsFree: true,
    Enabled: true,
  },
  {
    Name: "BTR",
    Permissions: ["Better"],
    URLProduct: "/better",
    IsFree: true,
    Enabled: true,
  },
  {
    Name: "ACM",
    Permissions: ["ACM"],
    URLProduct: "/acm",
    IsFree: true,
    Enabled: true,
  },
];
